/**
 * src/lib/picker.js — open a native date/time picker on click.
 *
 * By default a click on the text of an `<input type="date">` (or time /
 * datetime-local) only focuses a segment; the calendar opens from the small
 * icon at the edge, which people miss. `showPicker()` opens it from anywhere
 * on the field.
 *
 * Wired to `onClick`, not `onFocus`: a keyboard user tabbing through a form
 * should be able to type a date without a popup appearing, and showPicker()
 * needs a user gesture anyway.
 */

/**
 * Click handler for native date/time inputs.
 *
 * @param {React.MouseEvent<HTMLInputElement>} event
 * @returns {void}
 */
export function openNativePicker(event) {
  const input = event.currentTarget;
  if (input.disabled || input.readOnly || typeof input.showPicker !== 'function') return;
  try {
    input.showPicker();
  } catch {
    // Throws when the picker is already open, or in contexts that forbid it
    // (e.g. a cross-origin iframe). The field still works as a plain input.
  }
}
